import sdl from '@jds/react-generated-sdl/JDSBottomFooter';
import type { JDSBottomFooterProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBottomFooterProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSBottomFooter',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BottomFooter = withLogic(Component) as React.FC<JDSBottomFooterProps> & {
  slotName?: string;
};

BottomFooter.displayName = 'BottomFooter';
BottomFooter.slotName = 'jds_bottom_footer';

export { BottomFooter, type JDSBottomFooterProps };
